import api from '../axiosInstance';
import { BATCH_ENDPOINTS } from '../constants';

export const getBatch = (compId, customerId) => {
  const data = {
    comp_id : compId,
    customer_id : customerId
  }
  return api.post(BATCH_ENDPOINTS.LIST, data);
}

export const getBatchDetails = (batchId) => {
  const data = {
    batch_id : batchId,
  }
  return api.post(BATCH_ENDPOINTS.DETAILS_LIST, data);
}

export const cancelBatch = (batchId) => {
  const data = {
    batch_id : batchId,
  }
  return api.post(BATCH_ENDPOINTS.CANCEL, data);
}

export const exportBatch = (batchId) => {
  const data = {
    batch_id : batchId,
  }
  return api.post(BATCH_ENDPOINTS.EXPORT, data);
}